import { FC, useMemo } from 'react';
import { useAuthentication } from '@connect-x-app/hybrid-state';
import { RolesPermissions } from '@connect-x-app/shared-domain-models';

import { QuickRepliesTable } from '../../../../shared/components/QuickRepliesTable';
import { useRoleQuickReplyContentTable } from './_hooks/useRoleQuickReplyContentTable';

import './roleQuickReplies.scss';

export const RoleQuickReplies: FC = () => {
  const { hasPermission } = useAuthentication();

  const canUpdate = useMemo(() => {
    return hasPermission(RolesPermissions.UPDATE);
  }, [hasPermission]);

  const { create, isLoading, quickReplies, remove, selectedItems, table, updateRoleQuickReply } = useRoleQuickReplyContentTable({
    renderCheckbox: canUpdate,
  });

  return (
    <QuickRepliesTable
      deletePermission={canUpdate}
      isLoading={isLoading}
      isLoadingDeleteQuickReplies={isLoading}
      isLoadingUpdateQuickReplies={isLoading}
      onCreateQuickReply={quickReply => create(quickReply)}
      onDeleteQuickReplies={remove}
      onUpdateQuickReply={quickReply => updateRoleQuickReply(quickReply)}
      quickReplies={quickReplies}
      selectedItems={selectedItems}
      table={table}
      updatePermission={canUpdate}
    />
  );
};
